import React from 'react';
import './Breadcrumbs.css';
import { cleanInternalLinkUrl } from '../../../utils/cob-utils';
import { IconChevron } from '../../../importCL';

interface IGoogleSearchBreadcrumbs {
    url: string;
}

export const Breadcrumbs = ({ url }: IGoogleSearchBreadcrumbs) => {
    const replacements: {[key: string]: string} = {
        'articles/glossary': 'Glossary',
        'corporate/about-us/news-press': 'News Press',
        'articles': 'Keys to Credit',
        'faqs': 'FAQs',
    };
    const replacedUrl = url.replace(
        new RegExp(Object.keys(replacements).join('|'), 'g'),
        match => replacements[match],
    );
    const segments = cleanInternalLinkUrl(replacedUrl).split('/');
    const breadcrumbElements: string[] = [];

    for (const segment of segments) {
        const paginationMatch = segment.match(/\.\d+/);
        if (paginationMatch) {
            breadcrumbElements.push(segment.replace(paginationMatch[0], ''));
            const pageNumber = paginationMatch[0].slice(1);
            breadcrumbElements.push(`Page ${pageNumber}`);
        } else {
            breadcrumbElements.push(segment);
        }
    }

    const capitalizedBreadcrumbs = breadcrumbElements.map((breadcrumbElement: string) => {
        const words = breadcrumbElement.split('-');
        const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
        return capitalizedWords.join(' ');
    });
    capitalizedBreadcrumbs.shift();

    return (
        <div className='GoogleResultsBreadcrumbs'>
            {capitalizedBreadcrumbs.map((breadcrumbElement: string, i: number) => (
                <span key={i} className='GoogleResultsBreadcrumbs__breadcrumb'>
                    {breadcrumbElement}
                    {i < capitalizedBreadcrumbs.length - 1 && <IconChevron className='GoogleResultsBreadcrumbs__chevron' size='small' />}
                </span>
            ))}
        </div>
    );
};
